import api from "./core";

const basePath = "api/core/EligibilityServiceCodes";

export default {
  query() {
    return api.post(`${basePath}`);
  }
};
